import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M20.999 11H5.211L10.532 5.99002C10.934 5.61202 10.953 4.97902 10.574 4.57602C10.196 4.17502 9.563 4.15602 9.16 4.53402L2.532 10.774C2.208 11.081 2.017 11.504 2.001 11.944C2 11.963 2 11.981 2 12C2 12.019 2 12.039 2.001 12.058C2.017 12.497 2.209 12.92 2.533 13.225L9.161 19.465C9.354 19.647 9.6 19.736 9.847 19.736C10.113 19.736 10.378 19.631 10.575 19.422C10.953 19.02 10.934 18.387 10.533 18.008L5.213 13H21C21.553 13 22 12.552 22 12C22 11.448 21.552 11 20.999 11Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ArrowLeft');

export default Icon;
